import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=a8a4eef2"
import script from "./DownloadLink.vue?vue&type=script&lang=js"
export * from "./DownloadLink.vue?vue&type=script&lang=js"
import style0 from "./DownloadLink.vue?vue&type=style&index=0&id=a8a4eef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports